<template>
  <div class="bg-surface-default-low">
    <TradeInFooterLinks :title />
  </div>
</template>

<script setup lang="ts">
import type { TradeInFooterLinksApiProps } from '@backmarket/http-api/src/api-specs-content/models/trade-in-footer-links'
import TradeInFooterLinks from '@backmarket/nuxt-layer-buyback/components/TradeInFooterLinks/TradeInFooterLinks.vue'

import type { BlockProps } from '../../models/content-block'

export type TradeInFooterLinksBlockProps = TradeInFooterLinksApiProps &
  BlockProps

defineProps<TradeInFooterLinksBlockProps>()
</script>
